import { render, staticRenderFns } from "./upDownManageV2.vue?vue&type=template&id=d95a96d4&scoped=true"
import script from "./upDownManageV2.vue?vue&type=script&lang=js"
export * from "./upDownManageV2.vue?vue&type=script&lang=js"
import style0 from "./upDownManageV2.vue?vue&type=style&index=0&id=d95a96d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d95a96d4",
  null
  
)

export default component.exports